import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

import { SponsorService } from '../../../_services';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import {Store} from '@ngxs/store';
import {SetPageHeaderTitle} from '../../../core/data-management/actions/projects.action';

@Component({
  selector: 'app-imaging-project-sponsor',
  templateUrl: './imaging-project-sponsor.component.html',
  styleUrls: ['./imaging-project-sponsor.component.css']
})
export class ImagingProjectSponsorComponent implements OnInit {
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  requiredFormControl = new FormControl('', [
    Validators.required
  ]);
  sponsor: any = {};
  sponsors: any[] = [];
  toastOptions: ToastOptions = {
    title: "",
    showClose: true,
    timeout: 10000,
    theme: "material",
  };
  displayedColumns: string[] = ['row-num', 'name', 'emailAddress', 'department', 'postalAddress', 'phone', 'operations'];
  dataSource: MatTableDataSource<any>;

  showTable: boolean = true;
  showSponsor: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private sponsorService: SponsorService, private toastyService: ToastyService, private store: Store) { }

  ngOnInit() {
    this.store.dispatch(new SetPageHeaderTitle('Sponsors'));
    this.sponsorService.getAll().subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.sponsors = response.data;
          this.dataSource = new MatTableDataSource(this.sponsors);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastOptions.title = "ERROR " + response.responseCode;
          this.toastOptions.msg = response.responseMessage;
          this.toastyService.error(this.toastOptions);
        }
      }
    );
  }

  saveSponsor() {
    if (this.sponsor.id) {
      this.sponsorService.update(this.sponsor).subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            this.sponsorService.getAll().subscribe(
              (response: any) => {
                if (response.responseCode === 200) {
                  this.sponsors = response.data;
                  this.dataSource.data = response.data;
                  this.toastOptions.title = "";
                  this.toastOptions.msg = "Sponsor successfully updated";
                  this.toastyService.success(this.toastOptions);
                  this.hideSponsors();
                } else {
                  this.toastOptions.title = "ERROR " + response.responseCode;
                  this.toastOptions.msg = response.responseMessage;
                  this.toastyService.error(this.toastOptions);
                }
              }
            );
          } else {
            this.toastOptions.title = "ERROR " + response.responseCode;
            this.toastOptions.msg = response.responseMessage;
            this.toastyService.error(this.toastOptions);
          }
        }
      );
    } else {
      this.sponsorService.create(this.sponsor).subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            this.sponsorService.getAll().subscribe(
              (response: any) => {
                if (response.responseCode === 200) {
                  this.sponsors = response.data;
                  this.dataSource.data = response.data;
                  this.toastOptions.title = "";
                  this.toastOptions.msg = "Sponsor successfully created";
                  this.toastyService.success(this.toastOptions);
                  this.hideSponsors();
                } else {
                  this.toastOptions.title = "ERROR " + response.responseCode;
                  this.toastOptions.msg = response.responseMessage;
                  this.toastyService.error(this.toastOptions);
                }
              }
            );
          } else {
            this.toastOptions.title = "ERROR " + response.responseCode;
            this.toastOptions.msg = response.responseMessage;
            this.toastyService.error(this.toastOptions);
          }
        }
      );
    }
  }

  applyFilter(filterValue: string) {
    if (this.dataSource !== undefined) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  showSponsors(element) {
    this.sponsor = {};
    this.showTable = false;
    this.showSponsor = true;
    this.emailFormControl.clearValidators();
    this.requiredFormControl.clearValidators();
    if (element) {
      this.sponsorService.getById(element.id).subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            this.sponsor = response.data;
            this.store.dispatch(new SetPageHeaderTitle('Edit Sponsor'));
          }
        }
      );
    } else {
      this.store.dispatch(new SetPageHeaderTitle('Create Sponsor'));
    }
  }

  deleteSponsor(element) {
    this.sponsorService.delete(element.id).subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.sponsorService.getAll().subscribe(
            (response: any) => {
              if (response.responseCode === 200) {
                this.sponsors = response.data;
                this.dataSource.data = response.data;
              } else {
                this.toastOptions.title = "ERROR " + response.responseCode;
                this.toastOptions.msg = response.responseMessage;
                this.toastyService.error(this.toastOptions);
              }
            }
          );
          this.toastOptions.title = "";
          this.toastOptions.msg = "Sponsor successfully deleted.";
          this.toastyService.success(this.toastOptions);
        } else {
          this.toastOptions.title = "ERROR " + response.responseCode;
          this.toastOptions.msg = response.responseMessage;
          this.toastyService.error(this.toastOptions);
        }
      }
    );
  }

  hideSponsors() {
    this.showTable = true;
    this.showSponsor = false;
  }

}
